import { render, staticRenderFns } from "./VFatherProAnamCAxAAM.vue?vue&type=template&id=cb322d2e"
import script from "./VFatherProAnamCAxAAM.vue?vue&type=script&lang=js"
export * from "./VFatherProAnamCAxAAM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports